module.exports = __webpack_public_path__ + "img/slide6.39beebd3.png";